
import React from 'react';
import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from "@stripe/stripe-js/pure";
import App from "../../../App";
import {STRIPE_KEY} from "../../../config.json";

const stripePromise = loadStripe(STRIPE_KEY);

const AppHOC = () => (
    <Elements stripe={stripePromise}>
        <App/>
    </Elements>
);
export default AppHOC;
